// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Core__Array from "@rescript/core/src/Core__Array.bs.js";
import * as Core__Option from "@rescript/core/src/Core__Option.bs.js";
import * as Utils$OrcaPaymentPage from "../Utilities/Utils.bs.js";

let protocolVersionKey = "cardFormPortV";

let kindFieldStateUpdate = "fieldStateUpdate";

function encodeFieldStateUpdate(snapshot) {
  let sharedEntries = [
    [
      "cardBrand",
      snapshot.cardBrand
    ],
    [
      "fieldStatus",
      snapshot.fieldStatus
    ],
    [
      "cardInfo",
      snapshot.cardInfo
    ]
  ];
  let sharedEntries$1 = snapshot.focusReady ? sharedEntries.concat([[
        "focusReady",
        true
      ]]) : sharedEntries;
  let portEntries = sharedEntries$1.concat(Core__Array.filterMap([
    Core__Option.map(snapshot.rawCardNumber, v => [
      "rawCardNumber",
      v
    ]),
    Core__Option.map(snapshot.rawCardExpiry, v => [
      "rawCardExpiry",
      v
    ]),
    Core__Option.map(snapshot.rawCvc, v => [
      "rawCvc",
      v
    ])
  ], entry => entry));
  let portPayload = Object.fromEntries([
    [
      protocolVersionKey,
      1.0
    ],
    [
      "kind",
      kindFieldStateUpdate
    ],
    [
      "payload",
      Object.fromEntries(portEntries)
    ]
  ]);
  return {
    windowPayload: Object.fromEntries(sharedEntries$1),
    portPayload: portPayload
  };
}

function makePortFrame(kind, payload) {
  return Object.fromEntries([
    [
      protocolVersionKey,
      1.0
    ],
    [
      "kind",
      kind
    ],
    [
      "payload",
      payload
    ]
  ]);
}

function decodePortFrame(json) {
  let dict = Utils$OrcaPaymentPage.getDictFromJson(json);
  let versionJson = dict[protocolVersionKey];
  if (versionJson === undefined) {
    return;
  }
  let version = Utils$OrcaPaymentPage.getFloatFromJson(versionJson, 0.0);
  if (version !== 1.0) {
    console.warn(`[CardFormPortProtocol] decoding frame with version ` + version.toString() + `; expected ` + (1.0).toString());
  }
  return {
    kind: Utils$OrcaPaymentPage.getString(dict, "kind", ""),
    payload: Utils$OrcaPaymentPage.getJsonObjectFromDict(dict, "payload")
  };
}

let protocolVersion = 1.0;

let kindDoFocus = "doFocus";

let kindDetectedCardBrand = "detectedCardBrand";

let kindClearField = "clearField";

export {
  protocolVersion,
  protocolVersionKey,
  kindFieldStateUpdate,
  kindDoFocus,
  kindDetectedCardBrand,
  kindClearField,
  encodeFieldStateUpdate,
  makePortFrame,
  decodePortFrame,
}
/* Utils-OrcaPaymentPage Not a pure module */
